import styled from 'styled-components';
import { TextAreaProps } from './props';

export const StyledTextArea = styled.textarea<TextAreaProps & any>`
    padding: 17px 13px 1px 10px;
    border: none;
    outline: none;
    min-height: 44px !important;
    box-sizing: border-box;
    box-shadow: none;
    border: 1px #bfbfbf solid;
    color: #444;
    background: #fff;
    border-radius: 4px;
    font-size: 15px;
    width: 100%;
    height: 100%;
    resize: none;
    overflow-x: hidden;

    &:disabled {
        cursor: initial;
        opacity: 1;
    }

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-track {
        background : transparent;
        border-radius: 0px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 0px;
    }

    ${(props) =>
        !!props.isValid
            ? !props.isValid?.valid
                ? `border: 1px #b00020 solid;`
                : `border: 1px #33b216 solid;`
            : null}
`;

export const StyledLabel = styled.label<{ active?: boolean }>`
    position: absolute;
    left: 10px;
    color: #999;
    transition: 200ms;
    font-size: 14px;
    top: 14px;
    pointer-events: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    right: 0;

    ${props => props.active && `
        top: 3px;
        left: 5px;
        color: #888;
        background: transparent;
        padding: 0 20px 0 4px;
        font-size: 12px;
    `}
`;

export const Container = styled.div`
    position: relative;
    display: block !important;
`;
